import { RouteHttpVerb } from "@devowl-wp/utils";
const locationRestExportGet = {
    path: "/export",
    method: RouteHttpVerb.GET
};
export { locationRestExportGet };
